/** Mieterportal-Hülle (Handy zuerst): AppBar oben, Tab-Leiste unten. Etappe 3: Start und Vertrag; Artikel/Erfassen/Abrechnung folgen in Etappe 4/5. */
import { api, rufe } from "../api/client";
import { Marke } from "../ui/Marke";
import { NavLink, Outlet } from "react-router";
import { Icon } from "../ui";
import { useIch } from "../api/ich";
import { useMieterStart } from "./api";
import { useMieterLive } from "./live";
import { useEffect } from "react";
import { useCockpit } from "./cockpit-api";
import { spracheMerken, useT } from "../i18n";
import { useOfflineWarteschlange } from "./offline";

export function MieterShell() {
  const ich = useIch();
  const start = useMieterStart();
  const ck = useCockpit();
  const t = useT();
  const offline = useOfflineWarteschlange();
  useMieterLive();
  const anzeige = ck.data?.einstellungen.anzeige;
  const sprache = ck.data?.einstellungen.sprache;
  useEffect(() => {
    if (sprache) spracheMerken(sprache);
  }, [sprache]);
  const ladenName = start.data?.laden.name ?? ich.data?.mieterIn?.[0]?.name ?? "Mieterportal";
  return (
    <div className={["mp", anzeige?.grosseSchrift && "mp--gross", anzeige?.einfach && "mp--einfach"].filter(Boolean).join(" ")}>
      <header className="sc-bar">
        <div className="sc-row">
          {start.data?.laden.logo ? <img src={`/api/public/laden/${start.data.laden.slug}/logo`} alt="" className="app-logo" width={40} height={40} /> : <Marke size={40} />}
          <div className="sc-col" style={{ gap: 0 }}>
            <span className="sc-bar__title">{ladenName}</span>
            <span className="sc-muted sc-small">{t("nav.portal")} · {start.data?.mieter.name ?? ich.data?.benutzer?.name ?? ""}</span>
          </div>
        </div>
        {(ich.data?.mieterIn?.length ?? 0) > 1 ? (
          <select className="sc-select" aria-label="Laden wechseln" value={ich.data?.sitzung?.ladenId ?? ""} onChange={(e) => void rufe(api.api.auth.laden.$post({ json: { ladenId: e.target.value } })).then(() => window.location.assign("/mieter"))} style={{ maxWidth: 140 }}>
            {ich.data?.mieterIn?.map((l) => <option key={l.ladenId} value={l.ladenId}>{l.name}</option>)}
          </select>
        ) : null}
        <NavLink to="/mieter/profil" className="rg-btn rg-btn--quiet" aria-label="Profil">
          <Icon name="user" size={18} /> {t("nav.profil")}
        </NavLink>
      </header>
      <main className="mp__main">
        {offline.anzahl ? (
          <div className="mp-offline" role="status">
            <Icon name="clock" size={18} />
            <span style={{ flex: 1 }}>{offline.anzahl} {offline.anzahl === 1 ? "Artikel wartet" : "Artikel"} {t("offline.warten")}</span>
            <button type="button" className="rg-btn rg-btn--quiet" onClick={() => void offline.senden()}>{t("offline.senden")}</button>
          </div>
        ) : null}
        <Outlet />
      </main>
      <nav className="sc-tabbar" aria-label="Bereiche">
        <NavLink to="/mieter" end className={({ isActive }) => (isActive ? "is-on" : undefined)}><Icon name="layout-dashboard" size={22} /> {t("nav.start")}</NavLink>
        <NavLink to="/mieter/artikel" className={({ isActive }) => (isActive ? "is-on" : undefined)}><Icon name="tag" size={22} /> {t("nav.artikel")}</NavLink>
        <NavLink to="/mieter/erfassen" className={({ isActive }) => (isActive ? "is-on" : undefined)}><span className="sc-tabbar__plus"><Icon name="plus" size={24} /></span> {t("nav.erfassen")}</NavLink>
        <NavLink to="/mieter/abrechnungen" className={({ isActive }) => (isActive ? "is-on" : undefined)}><Icon name="receipt" size={22} /> {t("nav.abrechnung")}</NavLink>
        <NavLink to="/mieter/regal" className={({ isActive }) => (isActive ? "is-on" : undefined)}><Icon name="library" size={22} /> {t("nav.regal")}</NavLink>
      </nav>
    </div>
  );
}
